<template>
  <header class="HeaderComp absolute left-0 top-0 w-full h-15 md:h-20 px-3 md:px-5">
    <!--  -->
    <!-- CENTER ALIGN -->
    <!--  -->
    <div
      v-if="layoutSlug === 'center-align'"
      :class="innerClasses"
    >
      <div class="w-40%">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover flex items-center"
          >
            <BackBtn />
          </div>
        </transition>
      </div>
      <div class="max-h-full overflow-hidden flex-grow-1">
        <LogoLink />
      </div>
      <div class="w-40%">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover flex justify-end items-center"
          >
            <CtaList
              olClasses="mr-4 last:mr-0 hidden lg:flex items-center"
              liClasses="mr-2 last:mr-0"
              theme-settings="header"
              :limit="lteLaptop ? 1 : 2"
            />
            <MenuBtn />
          </div>
        </transition>
      </div>
    </div>
    <!--  -->
    <!-- LEFT ALIGN -->
    <!--  -->
    <div
      v-else-if="layoutSlug === 'left-align'"
      :class="innerClasses"
    >
      <div class="w-1/2 md:w-3/12 lg:w-2/12 flex items-center">
        <LogoLink />
      </div>
      <div class="hidden md:block flex-grow-1">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover overflow-hidden flex-c"
          >
            <CtaList
              olClasses="mr-4 last:mr-0 flex items-center"
              liClasses="mr-2 last:mr-0"
              theme-settings="header"
              :limit="lteTablet ? 1 : lteLaptop ? 2 : 3"
            />
          </div>
        </transition>
      </div>
      <div class="w-1/2 md:w-3/12 lg:w-2/12">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover flex justify-end items-center"
          >
            <BackBtn class="mr-4 lg:mr-8" />
            <MenuBtn />
          </div>
        </transition>
      </div>
    </div>
    <!--  -->
    <!-- RIGHT ALIGN -->
    <!--  -->
    <div
      v-else-if="layoutSlug === 'right-align'"
      :class="innerClasses"
    >
      <div class="w-1/2 md:w-3/12 lg:w-2/12">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover flex items-center"
          >
            <BackBtn class="mr-4 lg:mr-8" />
            <MenuBtn />
          </div>
        </transition>
      </div>
      <div class="hidden md:block flex-grow-1">
        <transition name="fade">
          <div
            v-show="showLinks"
            class="r-cover overflow-hidden flex-c"
          >
            <CtaList
              olClasses="mr-4 last:mr-0 flex items-center"
              liClasses="mr-2 last:mr-0"
              theme-settings="header"
              :limit="lteTablet ? 1 : lteLaptop ? 2 : 3"
            />
          </div>
        </transition>
      </div>
      <div class="w-1/2 md:w-3/12 lg:w-2/12 flex justify-end items-center">
        <LogoLink />
      </div>
    </div>
  </header>
</template>

<script>
import BackBtn from '@/components/buttons/BackBtn.vue'
import CtaList from '@/components/CtaList.vue'
import LogoLink from '@/components/buttons/LogoLink.vue'
import MenuBtn from '@/components/buttons/MenuBtn.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Header',

  components: {
    BackBtn,
    CtaList,
    LogoLink,
    MenuBtn
  },

  data: () => ({
    innerClasses: 'r-cover flex justify-between items-center',
  }),

  computed: {
    // Data
    ...mapState([
      'lteLaptop',
      'lteTablet'
    ]),
    ...mapGetters([
      'myStore',
      'isContentspot',
    ]),
    // Layout
    layoutSlug() { return this.myStore(['styles', 'header', 'layout']) ?? 'center-align' },
    // Nav
    showLinks() {
      const { isContentspot } = this
      return !isContentspot
    },
  },
}
</script>
